var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppTooltip',{attrs:{"noArrow":"","top":"","text":"Type / or click for more"}},[_c('IconButton',{staticClass:"flex-centerize",class:{ 'focus-animation': _vm.showFocusAnimation },attrs:{"tabindex":"-1","small":""},on:{"mousedown":_vm.onClick}},[_c('SIcon',{staticClass:"plus-icon",attrs:{"name":"plus-insert-data","width":10}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }